import React, { useRef, useEffect } from 'react';

import { SCROLL_CONFIG } from '../../../../shared/constants/scrollConstants';

const ViewAllPassesLink = () => {
    const animationFrameId = useRef<number | null>(null);

    useEffect(() => {
        return () => {
            if (animationFrameId.current !== null) {
                cancelAnimationFrame(animationFrameId.current);
            }
        };
    }, []);

    const handleScroll = (e: React.MouseEvent<HTMLAnchorElement>) => {
        e.preventDefault();

        if (animationFrameId.current !== null) {
            cancelAnimationFrame(animationFrameId.current);
        }

        const target = document.getElementById('delegate-pass-selection');
        if (!target) return;

        const headerElement = document.getElementById('site-header');
        const headerOffset = headerElement?.getBoundingClientRect().height || SCROLL_CONFIG.defaultHeaderHeight;

        const targetPosition = target.getBoundingClientRect().top + window.scrollY - headerOffset;
        const startPosition = window.scrollY;
        const distance = targetPosition - startPosition;
        const duration = SCROLL_CONFIG.duration;
        let start: number | null = null;

        const ease = (t: number, b: number, c: number, d: number) => {
            if (d === 0) return b;
            t /= d / 2;
            if (t < 1) return (c / 2) * t * t * t + b;
            t -= 2;
            return (c / 2) * (t * t * t + 2) + b;
        };

        const animation = (currentTime: number) => {
            if (start === null) start = currentTime;
            const timeElapsed = currentTime - start;
            const run = ease(timeElapsed, startPosition, distance, duration);
            window.scrollTo(0, run);

            if (timeElapsed < duration) {
                animationFrameId.current = requestAnimationFrame(animation);
            } else {
                animationFrameId.current = null;
            }
        };

        animationFrameId.current = requestAnimationFrame(animation);
    };

    return (
        <div className="w-full flex justify-center md:justify-start md:pl-[80px] mt-[12px] md:mt-[24px]">
            <a
                href="#delegate-pass-selection"
                onClick={handleScroll}
                className="flex items-center gap-[4px] text-white group no-underline"
            >
                <span className="font-noto text-[12px] font-weight-400 leading-[18px] text-white">
                    View all passes
                </span>
                <svg
                    width="8"
                    height="6"
                    viewBox="0 0 12 8"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                    className="-mt-[2px]"
                >
                    <path
                        d="M2 2L6 6L10 2"
                        stroke="white"
                        strokeWidth="1.5"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                    />
                </svg>
            </a>
        </div>
    );
};

export default ViewAllPassesLink;
